export default class PlayerLocal {

    constructor(game, name, avatar, id, rank, rating, position) {
        //public
        this.game = game;
        this.name = name;
        this.avatar = avatar;
        this.id = id;
        this.rank = rank;
        this.rating = rating;
        this.playerPosition = position;
        this.isLocal = true;
        if (typeof this.avatar == 'undefined') this.avatar = 'images/Avatars/default-avatar.png';
        this.game.showSelection = false;
        //todo: the model could send en event and this class listen to it, or it get called directly from the model as done below
    }

    gameEvent(message, value, location, player) {

        if (message == "start") this.start();
        if (message == "pause") this.pause();
        if (message == "resume") this.resume();
        if (message == "dispose") this.dispose();
        if (message == "destroy") this.destroy();
        if (message == "gameover") this.gameover();
    };

    start() {
    }
    pause() {
    }
    resume() {
    }
    dispose() {
    }
    destroy() {
    }
    gameover() {
    }

}